import { ProjectComponent } from './project.component';
import { ProjectService } from '@fuse/services/project.service';
var ɵ0 = ProjectService;
var routes = [
    {
        path: 'project/:id',
        component: ProjectComponent,
        pathMatch: 'full',
        resolve: {
            data: ɵ0
        }
    }
];
var ProjectModule = /** @class */ (function () {
    function ProjectModule() {
    }
    return ProjectModule;
}());
export { ProjectModule };
export { ɵ0 };
